export default __webpack_public_path__ + "static/media/icone-play-white.20837aac.svg";